<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="w-10 h-10 my-2 flex items-center justify-center rounded-lg fill-slate-700 hover:fill-red-600 relative"
      :class="{
        'bg-v4': isActive || isChildMenuActive,
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <fluent-icon
        v-if="
          icon != 'chat' &&
          (icon != 'settings') &
            (icon != 'library') &
            (icon != 'arrow-trending-lines') &
            (icon != 'book-contacts')
        "
        :icon="icon"
        class="hover:fill-red-600 fill-slate-700"
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        class="hover:fill-red-600 fill-slate-700"
        v-if="icon == 'chat'"
      >
        <path
          d="m14.928,9h.072c1.654,0,3-1.346,3-3v-3c0-1.654-1.346-3-3-3h-6c-1.654,0-3,1.346-3,3v3c0,1.654,1.346,3,3,3h.202l1.834,1.617c.29.256.653.384,1.016.384.358,0,.716-.126.998-.376l1.878-1.624Zm-2.877-.156l-1.81-1.594c-.183-.161-.418-.25-.661-.25h-.58c-.552,0-1-.449-1-1v-3c0-.551.448-1,1-1h6c.552,0,1,.449,1,1v3c0,.551-.448,1-1,1h-.444c-.24,0-.473.086-.654.244l-1.851,1.601Zm-6.551,9.156c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5,1.57,3.5,3.5,3.5Zm0-5c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm9.5,1.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5Zm3.5-1.5c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm-7.563,9.649c.193.517-.068,1.094-.585,1.288-.116.043-.234.064-.352.064-.404,0-.786-.248-.937-.649-.527-1.406-1.959-2.351-3.563-2.351s-3.036.945-3.563,2.351c-.194.518-.771.776-1.288.585-.517-.194-.778-.771-.585-1.288.818-2.183,3.003-3.649,5.437-3.649s4.618,1.466,5.437,3.649Zm12.415,1.288c-.116.043-.234.064-.352.064-.404,0-.786-.248-.937-.649-.527-1.406-1.959-2.351-3.563-2.351s-3.036.945-3.563,2.351c-.194.518-.771.776-1.288.585-.517-.194-.778-.771-.585-1.288.818-2.183,3.003-3.649,5.437-3.649s4.618,1.466,5.437,3.649c.193.517-.068,1.094-.585,1.288Z"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        class="hover:fill-red-600 fill-slate-700"
        v-if="icon == 'settings'"
      >
        <path
          d="m24,8.5v8c0,2.481-2.019,4.5-4.5,4.5h-7v2h4c.276,0,.5.224.5.5s-.224.5-.5.5H7.5c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h4v-2h-7c-2.481,0-4.5-2.019-4.5-4.5v-8c0-2.055,1.388-3.847,3.375-4.358.269-.071.54.093.609.36.068.267-.093.54-.359.609-1.546.397-2.625,1.792-2.625,3.39v8c0,1.93,1.57,3.5,3.5,3.5h15c1.93,0,3.5-1.57,3.5-3.5v-8c0-1.598-1.079-2.992-2.625-3.39-.267-.069-.428-.341-.359-.609.069-.267.34-.431.609-.36,1.987.511,3.375,2.304,3.375,4.358Zm-14-1.5c0-1.103.897-2,2-2s2,.897,2,2-.897,2-2,2-2-.897-2-2Zm1,0c0,.551.448,1,1,1s1-.449,1-1-.448-1-1-1-1,.449-1,1Zm-4.506,1.478l.646-.377c-.094-.384-.14-.747-.14-1.1s.046-.716.14-1.101l-.646-.376c-.714-.418-.956-1.338-.539-2.052s1.337-.957,2.052-.54l.641.375c.537-.489,1.166-.852,1.853-1.068v-.738c0-.827.673-1.5,1.5-1.5s1.5.673,1.5,1.5v.738c.687.216,1.316.579,1.853,1.068l.642-.374c.346-.203.749-.256,1.137-.156.388.102.712.349.914.695.417.714.175,1.635-.539,2.052l-.646.377c.094.386.14.749.14,1.101s-.046.715-.14,1.1l.646.377c.347.202.593.526.694.914.103.387.047.791-.155,1.137s-.526.593-.914.695c-.391.102-.792.045-1.137-.156l-.642-.374c-.536.489-1.166.852-1.853,1.068v.738c0,.827-.673,1.5-1.5,1.5s-1.5-.673-1.5-1.5v-.738c-.687-.216-1.315-.579-1.853-1.068l-.641.374c-.715.417-1.635.175-2.052-.539-.417-.714-.175-1.634.539-2.051Zm.324,1.547c.139.238.446.318.685.179l.971-.566c.078-.046.165-.068.252-.068.135,0,.268.054.364.158.55.586,1.249.989,2.021,1.165.228.052.389.254.389.487v1.121c0,.276.225.5.5.5s.5-.224.5-.5v-1.121c0-.233.161-.436.389-.487.773-.176,1.473-.579,2.021-1.165.161-.171.415-.207.617-.09l.972.567c.115.067.253.085.379.052.129-.034.237-.116.305-.231.067-.116.086-.25.052-.379s-.116-.237-.231-.304l-.979-.572c-.201-.118-.295-.358-.226-.581.138-.441.202-.819.202-1.188s-.064-.748-.202-1.189c-.069-.222.024-.463.226-.581l.979-.571c.238-.139.318-.446.18-.685-.067-.115-.176-.197-.305-.231-.126-.032-.263-.016-.379.052l-.972.567c-.199.117-.456.082-.617-.09-.548-.586-1.247-.988-2.021-1.165-.228-.052-.389-.254-.389-.487v-1.12c0-.276-.225-.5-.5-.5s-.5.224-.5.5v1.12c0,.233-.161.436-.389.487-.772.176-1.472.579-2.021,1.165-.159.171-.417.207-.616.09l-.971-.567c-.238-.138-.546-.059-.685.18s-.058.545.181.685l.979.571c.201.118.295.359.225.582-.138.439-.202.817-.202,1.188s.064.748.202,1.188c.07.223-.022.464-.225.582l-.979.572c-.238.139-.318.446-.18.684Z"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Filled"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        class="hover:fill-red-600 fill-slate-700"
        v-if="icon == 'library'"
      >
        <path
          d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,20a1,1,0,1,1,1-1A1,1,0,0,1,12,20Zm1.93-7.494A1.982,1.982,0,0,0,13,14.257V15a1,1,0,0,1-2,0v-.743a3.954,3.954,0,0,1,1.964-3.5,2,2,0,0,0,1-2.125,2.024,2.024,0,0,0-1.6-1.595A2,2,0,0,0,10,9,1,1,0,0,1,8,9a4,4,0,1,1,5.93,3.505Z"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        class="hover:fill-red-600 fill-slate-700"
        v-if="icon == 'arrow-trending-lines'"
      >
        <path
          d="m5.882,15H.5c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h5.382c.191,0,.362-.106.447-.276l1.048-2.096c.209-.419.627-.664,1.098-.639.468.025.86.312,1.024.75l1.939,5.17c.03.081.093.101.14.103.054.003.112-.01.15-.087l1.048-2.096c.256-.511.77-.829,1.342-.829h4.382c.276,0,.5.224.5.5s-.224.5-.5.5h-4.382c-.191,0-.362.106-.447.276l-1.048,2.096c-.2.399-.592.641-1.033.641-.021,0-.043,0-.064-.002-.468-.025-.86-.312-1.024-.75l-1.939-5.17c-.03-.081-.093-.101-.14-.103-.049.005-.112.011-.15.087l-1.048,2.096c-.256.511-.77.829-1.342.829Zm16.118-5.015v9.515c0,2.481-2.019,4.5-4.5,4.5H6.5c-2.481,0-4.5-2.019-4.5-4.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0,1.93,1.57,3.5,3.5,3.5h11c1.93,0,3.5-1.57,3.5-3.5v-9.515c0-.335-.038-.663-.096-.985h-5.404c-1.378,0-2.5-1.122-2.5-2.5V1.096c-.323-.058-.651-.096-.985-.096h-5.515c-1.93,0-3.5,1.57-3.5,3.5v7c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-7C2,2.019,4.019,0,6.5,0h5.515c1.736,0,3.369.676,4.596,1.904l3.485,3.485c1.228,1.228,1.904,2.86,1.904,4.596Zm-1.379-1.985c-.273-.704-.682-1.354-1.231-1.904l-3.485-3.485c-.55-.55-1.2-.959-1.904-1.231v5.121c0,.827.673,1.5,1.5,1.5h5.121Z"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        class="hover:fill-red-600 fill-slate-700"
        v-if="icon == 'book-contacts'"
      >
        <path
          d="m18.5,0H7.5c-1.956,0-3.624,1.254-4.243,3h-1.757c-.276,0-.5.224-.5.5s.224.5.5.5h1.528c-.018.164-.028.331-.028.5v2.5h-1.5c-.276,0-.5.224-.5.5s.224.5.5.5h1.5v3.5h-1.5c-.276,0-.5.224-.5.5s.224.5.5.5h1.5v3.5h-1.5c-.276,0-.5.224-.5.5s.224.5.5.5h1.5v2.5c0,.169.01.336.028.5h-1.528c-.276,0-.5.224-.5.5s.224.5.5.5h1.757c.619,1.746,2.287,3,4.243,3h11c2.481,0,4.5-2.019,4.5-4.5V4.5c0-2.481-2.019-4.5-4.5-4.5Zm3.5,19.5c0,1.93-1.57,3.5-3.5,3.5H7.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h11c1.93,0,3.5,1.57,3.5,3.5v15Zm-9-7.5c1.654,0,3-1.346,3-3s-1.346-3-3-3-3,1.346-3,3,1.346,3,3,3Zm0-5c1.103,0,2,.897,2,2s-.897,2-2,2-2-.897-2-2,.897-2,2-2Zm5,11v.5c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-.5c0-2.206-1.794-4-4-4s-4,1.794-4,4v.5c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-.5c0-2.757,2.243-5,5-5s5,2.243,5,5Z"
        />
      </svg>

      <span class="sr-only">{{ name }}</span>
      <span
        v-if="count"
        class="text-black-900 bg-yellow-600 absolute -top-1 -right-1"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>
<script>
export default {
  mounted() {
    console.log(this.icon);
  },
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<stlye scoped>
  .bg-v4{
  background: #E0E0E0;
}

</stlye>
